/** Paralympic store taxonomy — mirrors application/models/paralympic/categories.py */

export const PARALYMPIC_CATEGORIES = [
  { code: 1, name: "Wheelchair sports" },
  { code: 2, name: "Throwing" },
  { code: 3, name: "Race running" },
  { code: 4, name: "Shooting" },
  { code: 5, name: "Boccia" },
  { code: 6, name: "Wheelchair fencing" },
  { code: 7, name: "Swimming" },
  { code: 8, name: "Powerlifting" },
  { code: 9, name: "Sitting volleyball" },
  { code: 10, name: "Racket sports" },
  { code: 11, name: "Cycling" },
  { code: 12, name: "Adaptive accessories" },
];

export const PARALYMPIC_TYPES = [
  { code: 101, category: 1, name: "Racing wheelchair (track)" },
  { code: 102, category: 1, name: "Racing wheelchair (road)" },
  { code: 103, category: 1, name: "Basketball wheelchair" },
  { code: 104, category: 1, name: "Rugby wheelchair" },
  { code: 105, category: 1, name: "Tennis wheelchair" },
  { code: 106, category: 1, name: "Cambered pushrim" },
  { code: 107, category: 1, name: "Coated handrim" },
  { code: 108, category: 1, name: "Anti-tip bar" },
  { code: 109, category: 1, name: "Racing glove" },
  { code: 110, category: 1, name: "Pushrim grip" },
  { code: 201, category: 2, name: "Grip club" },
  { code: 202, category: 2, name: "Throwing frame" },
  { code: 203, category: 2, name: "Seat support" },
  { code: 204, category: 2, name: "Grip tape" },
  { code: 205, category: 2, name: "Throw harness" },
  { code: 301, category: 3, name: "RaceRunner frame" },
  { code: 302, category: 3, name: "Chest support" },
  { code: 303, category: 3, name: "Footplate" },
  { code: 401, category: 4, name: "Shooting stand" },
  { code: 402, category: 4, name: "Shooting rest" },
  { code: 403, category: 4, name: "Grip modification" },
  { code: 404, category: 4, name: "Mouth trigger" },
  { code: 405, category: 4, name: "Shooting mat" },
  { code: 501, category: 5, name: "Boccia ramp" },
  { code: 502, category: 5, name: "Ramp accessory" },
  { code: 503, category: 5, name: "Boccia ball" },
  { code: 504, category: 5, name: "Measuring tool" },
  { code: 505, category: 5, name: "Ball pointer" },
  { code: 601, category: 6, name: "Fencing chair" },
  { code: 602, category: 6, name: "Fencing harness" },
  { code: 603, category: 6, name: "Fencing jacket" },
  { code: 701, category: 7, name: "Kickboard" },
  { code: 702, category: 7, name: "Swim glove" },
  { code: 703, category: 7, name: "Pull buoy" },
  { code: 704, category: 7, name: "Swim tether" },
  { code: 801, category: 8, name: "Bench shirt" },
  { code: 802, category: 8, name: "Lifting belt" },
  { code: 803, category: 8, name: "Wrist/knee wrap" },
  { code: 901, category: 9, name: "Sitting net" },
  { code: 902, category: 9, name: "Court marker" },
  { code: 903, category: 9, name: "Impact shorts" },
  { code: 904, category: 9, name: "Slide pants" },
  { code: 905, category: 9, name: "Kneepad" },
  { code: 1001, category: 10, name: "Footplate" },
  { code: 1002, category: 10, name: "Custom racket" },
  { code: 1003, category: 10, name: "Ball pickup" },
  { code: 1101, category: 11, name: "Handcycle" },
  { code: 1102, category: 11, name: "Adaptive trike" },
  { code: 1103, category: 11, name: "Leg holder" },
  { code: 1104, category: 11, name: "Arm fairing" },
  { code: 1201, category: 12, name: "Prosthetic grip" },
  { code: 1202, category: 12, name: "Running blade" },
  { code: 1203, category: 12, name: "Elastic lace" },
  { code: 1204, category: 12, name: "Adaptive glove" },
  { code: 1205, category: 12, name: "Head mirror" },
];

export function typesForCategory(categoryCode) {
  const cat = Number(categoryCode);
  if (!cat) return [];
  return PARALYMPIC_TYPES.filter((row) => row.category === cat);
}
